import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    id: 'App.TaskTab.DuplicatesModal.Title',
    defaultMessage: 'Merge Potential Duplicates',
  },
  modalDescription: {
    id: 'App.TaskTab.DuplicatesModal.Description',
    defaultMessage: `Fortress identifies duplicate profiles when two or more of the following 
    fields match for a prospect: Name, Phone number or email address.`,
  },
  bannerText: {
    id: 'App.TaskTab.DuplicatesModal.BannerText',
    defaultMessage: `You can keep one Name and up to three contacts each for Phone, Email, 
    and Lead Source. Any items not selected will be removed.`,
  },
  primaryProfile: {
    id: 'App.TaskTab.DuplicatesModal.PrimaryProfile',
    defaultMessage: 'Current Primary Profile',
  },
  possibleDuplicate: {
    id: 'App.TaskTab.DuplicatesModal.PossibleDuplicate',
    defaultMessage: 'Possible Duplicate',
  },
  name: {
    id: 'App.TaskTab.DuplicatesModal.Name',
    defaultMessage: 'Name',
  },
  preferredName: {
    id: 'App.TaskTab.DuplicatesModal.PreferredName',
    defaultMessage: 'Preferred Name',
  },
  phone: {
    id: 'App.TaskTab.DuplicatesModal.Phone',
    defaultMessage: 'Phone',
  },
  email: {
    id: 'App.TaskTab.DuplicatesModal.Email',
    defaultMessage: 'Email',
  },
  household: {
    id: 'App.TaskTab.DuplicatesModal.Household',
    defaultMessage: 'Household',
  },
  cancelButton: {
    id: 'App.TaskTab.DuplicatesModal.CancelButton',
    defaultMessage: 'Cancel',
  },
  notAMatchButton: {
    id: 'App.TaskTab.DuplicatesModal.NotAMatchButton',
    defaultMessage: 'Not a Match',
  },
  mergeContactButton: {
    id: 'App.TaskTab.DuplicatesModal.MergeContactButton',
    defaultMessage: 'Merge this Contact',
  },
  removeFromQueueTitle: {
    id: 'App.TaskTab.DuplicatesCard.RemoveFromQueueTitle',
    defaultMessage: 'Remove Prospect from Queue',
  },
  confirmRemovalMessage: {
    id: 'App.TaskTab.DuplicatesCard.ConfirmRemovalMessage',
    defaultMessage:
      'Are you sure this guest card is <strong>"not a match"</strong>? This will remove it from your review queue.',
  },
  confirmButton: {
    id: 'App.TaskTab.DuplicatesCard.ConfirmButton',
    defaultMessage: 'Confirm',
  },
  mergePotentialDuplicatesTitle: {
    id: 'App.TaskTab.DuplicatesCard.MergePotentialDuplicatesTitle',
    defaultMessage: 'Merge Potential Duplicates',
  },
  confirmMergeMessage: {
    id: 'App.TaskTab.DuplicatesCard.ConfirmMergeMessage',
    defaultMessage:
      'Confirm the merged contact information for <strong>{contactName}</strong>.',
  },
  mergeWarningBanner: {
    id: 'App.TaskTab.DuplicatesCard.MergeWarningBanner',
    defaultMessage:
      'You cannot undo this action once completed. Please be sure you thoroughly ' +
      'review the contact information before you proceed.',
  },
  selectProfileRequired: {
    id: 'App.TaskTab.DuplicatesModal.SelectProfileRequired',
    defaultMessage:
      'Please select which profile you wish to keep before merging.',
  },
  portalAccountWarning: {
    id: 'App.TaskTab.DuplicatesModal.PortalAccountWarning',
    defaultMessage: 'This email is linked to an active Portal Account',
  },
  selectProfileToKeep: {
    id: 'App.TaskTab.DuplicatesModal.SelectProfileToKeep',
    defaultMessage: 'Select Profile to Keep',
  },
  currentPrimaryProfile: {
    id: 'App.TaskTab.DuplicatesModal.CurrentPrimaryProfile',
    defaultMessage: 'Current Primary Profile',
  },
  portalBadge: {
    id: 'App.TaskTab.DuplicatesModal.PortalBadge',
    defaultMessage: 'Active',
  },
  selectPrimaryProfile: {
    id: 'App.TaskTab.DuplicatesModal.SelectPrimaryProfile',
    defaultMessage: 'Select this as the primary profile',
  },
  selectProfileTooltip: {
    id: 'App.TaskTab.DuplicatesModal.SelectProfileTooltip',
    defaultMessage:
      'Select the profile you want to keep. Other profiles will merge into this record.',
  },
  portalEmailSelectionTitle: {
    id: 'App.TaskTab.DuplicatesModal.PortalEmailSelectionTitle',
    defaultMessage: 'Portal Email Selection',
  },
  portalEmailSelectionDescription: {
    id: 'App.TaskTab.DuplicatesModal.PortalEmailSelectionDescription',
    defaultMessage:
      'All emails listed above will merge to the new profile, but only one portal account ' +
      'can stay active. Select which email should keep portal access; any other active portal accounts ' +
      'will be deleted after the merge.',
  },
});

export default messages;
